/*
Sohel 03/01/2023 3075154998 Map Record Group Changes
Sai maheshwar 01/04/2023 2701334326 Add Record Group
Sohel 01/04/2023 2701334326 integrated Save and get API
Sohel 01/05/2023 2789725780 added SubPosition and fixed length changes
Sohel 01/06/2023 2789725780 removed condition
Sohel 01/06/2023 2789725780 changed Condition
dilip 01/07/2023 2789725780 Uncheck delete and mappedId functionality for Record Group
dilip 01/10/2023 2789725780 Added unsaved popup.
Sohel 01/13/2023 2789725780 Payload Changes
Ashraf 01/13/2023 2789725780 Changed table text when there are no records
manikanta  01/13/2023  2698967587,2699391155, 3075145357 Added breadCrums
Sohel 01/16/2023 2789725780 fixed Fields payload Issue
 dilip 01/16/2023 2789725780 Added Add Master Record button and functionality.
 dilip 01/16/2023 2789725780 Added Condition to display Add Master Record Button.
 dilip 01/17/2023 2789725780 Added Condition to display Add Master Record Button based on Group Type.
Sohel 01/20/2023 2789725780 Added LastStep in payload
Sohel 01/22/2023 2789725780 rename Save button
Ashraf 01/27/2023 2789725780 props for conditional render of payload
Sohel 01/31/2023 2698964415 payload changes
Dilip 02/01/2023 2698964415 code and description label changes
Sohel 01/08/2023 2701335619 implemented Usage Functionality
Rohini 02/09/2023 2701335619 added classnames for buttons
Raghu 04/05/2023 2701335619 fixed button alignments
Prakash 12-04-23 2701335619 add margin top  in export-record.
Prakash 04/26/2023 3225736869 fixed button speacing issues
Sohel 04/27/2023 3225736869 removed default username and password
Akhila 06/09/2023 2701335619 bug fix label name condtionally implemented
Akhila 06/12/2023 2701335619 added role access
Ravi 06/19/2023 2701335619 Added Breadcrum in popup
Ravi 06/23/2023 2701335619 fixed submit issue
uday 15/12/2023 2701335619  fixed button alignmets issues
*/
import React, {useContext, useEffect, useRef, useState} from 'react';
import {Field, FieldArray, Form, Formik} from 'formik';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {Button, Tooltip} from '@material-ui/core';
import DialogBox from '../../../../../components/DialogBox';
import AddIcon from '@material-ui/icons/Add';
import {useSelector, useDispatch} from 'react-redux';
import * as Yup from 'yup';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import SearchImportRecordGroupTable from '../../DataManagerRecord/SearchDataManagerRecord';
import GroupRecord from './GroupRecord';
import {
  postRecordGroup,
  fetchRecordGroupData,
  resetMapRecord,
} from '../../../../../redux/reducers/DataManagerRecordGroup';
import {DragDropContext, Droppable} from 'react-beautiful-dnd';
import BreadCrums from '../../../../../util/BreadCrum';
import {resetPrintUsageData} from '../../../../../redux/reducers/printUsage';
import {submissionStart} from '../../../../../redux/reducers/CommonActions/commonActions';
function MapRecordGroup({
  handleBack,
  exportManagerRecordGroup,
  setValue,
  showAlertRef,
  handleDirty,
  handleNext,
  exportRecordGroupAccess,
  importRecordGroupAccess,
  editExisting,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const {recordType, fixedLength} = useSelector(
    ({dataManagerRecordGroup}) => dataManagerRecordGroup,
  );
  const [open, setOpen] = useState(false);
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const saveRef = useRef('');
  const {
    isLoading,
    successMsg,
    errorMsg,
    groupCode,
    dmRecordGroupId,
    mapRecordData,
    addMapRecordStatus,
    basicInfoData,
    isDraftRecordGroup,
  } = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  const initialVal = {
    groupRecords: [],
  };
  const [initialValues, setInitialValues] = useState(initialVal);
  const masterRecordRef = useRef('');
  const type = exportManagerRecordGroup ? 'Export' : 'Import';
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);
  useEffect(() => {
    if (errorMsg || successMsg) {
      setTimeout(() => {
        if (successMsg && !saveRef.current && addMapRecordStatus === 200) {
          // setValue(0);
          handleNext && handleNext();
        }
        dispatch(resetMapRecord());
      }, 1500);
    }
  }, [errorMsg, successMsg, addMapRecordStatus]);

  const dmArrayHelpers = useRef();
  const dispatch = useDispatch();
  // const recordGroupType = { value: "New Payment Import" }
  const validationSchema = Yup.object().shape({
    groupRecords: Yup.array().of(
      Yup.object().shape({
        recordIdentifier: Yup.string().required('Record Identifier is required'),
      }),
    ),
  });
  const reorderItems = (startIndex, endIndex) => {
    const {values, setFieldValue} = dmArrayHelpers?.current?.form;
    const arr = [...values.groupRecords];
    const [removed] = arr.splice(startIndex, 1);
    arr.splice(endIndex, 0, removed);
    setFieldValue('groupRecords', arr);
  };
  const onDragEnd = (result) => {
    const {source, destination} = result;
    if (!destination) {
      return;
    }
    reorderItems(source.index, destination.index);
  };
  useEffect(() => {
    if (mapRecordData?.length > 0) {
      const data = mapRecordData?.map((el) => {
        return {
          ...el,
          recordCode: el?.recordFormatCode ? el?.recordFormatCode : '',
          recordCodeDescription: el?.recordCodeDescription ? el?.recordCodeDescription : '',
          recordIdentifier: el?.recordIdentifier ? el?.recordIdentifier : '',
          subLength: el?.subIdentifierLength ? el?.subIdentifierLength : '',
          subStart: el?.subIdentifierStart ? el?.subIdentifierStart : '',
          subValue: el?.subIdentifierValue ? el?.subIdentifierValue : '',
          dmRecordGroupMappingId: el?.dmRecordGroupMappingId ? el?.dmRecordGroupMappingId : 0,
          recordDescription: el?.recordDescription ? el?.recordDescription : '',
          subPosition: el?.subIdentifierPosition ? el?.subIdentifierPosition : '',
          masterRecord: el?.masterRecord || '',
        };
      });
      setInitialValues({...initialValues, groupRecords: data});
    }
  }, [mapRecordData]);
  const columns = [
    {
      title: 'Actions',
    },
    {
      title: 'SeqNo',
    },
    {
      title: 'Record Identifier',
    },
    {
      title: 'Sub Identifier Start',
      hidden: fixedLength === 'N',
    },
    {
      title: 'Sub Identifier Length',
      hidden: fixedLength === 'N',
    },
    {
      title: 'Sub Identifier Position',
      hidden: fixedLength === 'Y',
    },
    {
      title: 'Sub Identifier Value',
    },
    {
      title: 'Record Format',
    },
    {
      title: 'Record Format Description',
    },
  ];

  const onSubmit = (values) => {
    if (groupCode) {
      dispatch(submissionStart());
      const obj = {};
      const obj2 = {};
      mapRecordData?.forEach((row) => {
        obj[row?.recordFormatCode] = row?.dmRecordGroupMappingId;
        obj2[row?.recordFormatCode] = row?.dmRecordGroupMappingId;
      });
      values.groupRecords?.forEach((row2) => {
        if (obj[row2?.recordCode]) {
          delete obj[row2?.recordCode];
        }
      });
      const recordGroupVo = values.groupRecords.map((el, index) => {
        const existingIds = obj2[el.recordCode] ? obj2[el.recordCode] : null;
        return {
          dmRecordGroupMappingId: el?.dmRecordGroupMappingId ?
            el?.dmRecordGroupMappingId :
            existingIds ?
              existingIds :
              0,
          dmRecordId: el?.dataManagerRecordId ? el?.dataManagerRecordId : el?.dmRecordId ? el?.dmRecordId : 0,
          recordFormatCode: el?.recordCode ? el?.recordCode : '',
          recordGroupCode: groupCode,
          isDraft: isDraftRecordGroup ? isDraftRecordGroup : 'Y',
          recordIdentifier: el?.recordIdentifier ? el?.recordIdentifier : '',
          subIdentifierLength: fixedLength === 'Y' && el?.subLength ? Number(el?.subLength) : 0,
          subIdentifierStart: fixedLength === 'Y' && el?.subStart ? Number(el?.subStart) : 0,
          subIdentifierValue: el?.subValue ? el?.subValue : '',
          tabType: exportManagerRecordGroup ? 'Export' : 'Import',
          recordDescription: el?.recordDescription ? el?.recordDescription : '',
          seqNo: index + 1,
          subIdentifierPosition:
            fixedLength === 'N' && el?.subPosition ? Number(el?.subPosition) : '',
          masterRecord: el?.masterRecord || '',
        };
      });
      console.log(values.groupRecords, "values.groupRecordsvalues.groupRecords")
      const payload = {
        dmRecordGroupMapRequests: recordGroupVo,
        deleteIds: Object.values(obj).length > 0 ? Object.values(obj) : [],
        recordGroupCode: groupCode,
        recordGroupID: dmRecordGroupId,
        tabType: exportManagerRecordGroup ? 'Export' : 'Import',
        lastStep: saveRef?.current ?
          basicInfoData?.lastStep :
          isDraftRecordGroup === 'N' ?
            basicInfoData?.lastStep :
            2,
        isDraft: 'N',
      };
      dispatch(postRecordGroup(payload));
    }
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (dmRecordGroupId) {
      dispatch(fetchRecordGroupData(dmRecordGroupId));
    }
  }, [dmRecordGroupId]);
  useEffect(() => {
    if (addMapRecordStatus === 200 && successMsg) {
      dispatch(fetchRecordGroupData(dmRecordGroupId));
    }
  }, [successMsg, addMapRecordStatus]);
  const disabledCondition = (data) => {
    return (data || []).filter((item) => item?.masterRecord === 'Y')?.length === 0;
  };
  const masterRecordCondition =
    ['New Account Import', 'New Payment Import', 'Data Update'].includes(
      basicInfoData?.groupType,
    ) && !exportManagerRecordGroup;
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={(values) => onSubmit(values)}
        validateOnChange
      >
        {(props) => {
          const {values, setFieldValue, submitForm, dirty} = props;
          handleDirty && handleDirty(dirty);
          return (
            <>
              <Form noValidate>
                <FieldArray
                  name="groupRecords"
                  render={(arrayHelpers) => {
                    dmArrayHelpers.current = arrayHelpers;
                    return (
                      <>
                        <div className="table-header new-standard-textfields justify-content-between d-md-block">
                          <div>
                            <BreadCrums
                              name={`${type} Record Group Name`}
                              code={basicInfoData?.groupCode}
                              description={`${type} Record Group Description`}
                              descriptionValue={basicInfoData?.groupDescription}
                              returnType={'Type'}
                              returnTypeValue={basicInfoData?.groupType || ''}
                            />
                          </div>
                          <div className='d-flex justify-content-end'>
                            {masterRecordCondition ? (
                              <Button
                                variant="outlined"
                                className={`search-btn mx-1 ${classes.buttonRoot}`}
                                disabled={
                                  values?.groupRecords?.filter((item) => item?.masterRecord === 'Y')
                                    ?.length >= 1
                                }
                                onClick={() => {
                                  masterRecordRef.current = 'Y';
                                  setOpen(true);
                                }}
                                startIcon={<AddIcon />}
                              >
                                Master Record
                              </Button>
                            ) : null}
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              onClick={() => {
                                if (masterRecordCondition) {
                                  masterRecordRef.current = 'N';
                                }
                                setOpen(true);
                              }}
                              startIcon={<AddIcon />}
                            >
                              Record
                            </Button>
                          </div>
                        </div>
                        <div
                          className={
                            'mui-custom-table-container custom-table  pt-0 global-field-table text-center-table new-standard-textfields'
                          }
                        >
                          <DragDropContext onDragEnd={onDragEnd}>
                            <table>
                              <thead className="recFormat-header-container">
                                <tr>
                                  {columns.map(
                                    ({title, hidden = false}) =>
                                      !hidden && (
                                        <th key={title} className="recFormat-header">
                                          {title}
                                        </th>
                                      ),
                                  )}
                                </tr>
                              </thead>

                              {/* {values.groupRecords?.length > 0 ? (
                                <Droppable droppableId="droppabe-list">
                                  {(provided) => (
                                    <tbody ref={provided.innerRef} className="recFormat-body">
                                      {values.groupRecords.map((field, index) => (
                                        <>
                                          <Field
                                            key={index}
                                            name={`groupRecords[${index}]`}
                                            component={GroupRecord}
                                            index={index}
                                            columns={columns}
                                            dmArrayHelpers={dmArrayHelpers}
                                            deletedIds={deletedIds}
                                            setDeletedIds={setDeletedIds}
                                          />
                                        </>
                                      ))}
                                      {provided.placeholder}

                                    </tbody>

                                  )}
                                </Droppable>
                              ) : (
                                <tbody>
                                  <tr>
                                    <td colSpan={columns.length}>
                                      No records to display. To add fields to your report click the
                                      "Map Fields" button in the top right of this section.
                                    </td>
                                  </tr>
                                </tbody>
                              )} */}
                              <Droppable droppableId="droppabe-list">
                                {(provided) => (
                                  <tbody ref={provided.innerRef} className="recFormat-body">
                                    {values.groupRecords?.length > 0 ? (
                                      values.groupRecords?.map((rowData, index) => {
                                        return (
                                          <Field
                                            key={index}
                                            name={'groupRecords[' + index + ']'}
                                            component={GroupRecord}
                                            index={index}
                                            columns={columns}
                                            dmArrayHelpers={dmArrayHelpers}
                                            fixedLength={fixedLength}
                                            editExisting={editExisting}
                                            exportRecordGroupAccess={exportRecordGroupAccess}
                                            importRecordGroupAccess={importRecordGroupAccess}
                                          />
                                        );
                                      })
                                    ) : (
                                      <tr>
                                        <td colSpan={columns.length}>
                                          No records to display. To add records to your record group
                                          click the &quot;+ Record&quot; button in the top right of this
                                          section.
                                        </td>
                                      </tr>
                                    )}
                                    {provided.placeholder}
                                  </tbody>
                                )}
                              </Droppable>
                            </table>
                          </DragDropContext>
                        </div>
                        <DialogBox
                          open={open}
                          dialogClose={handleClose}
                          // title="Search Record"
                          title={
                            <div className="dialog-breadcrum">
                              <p className="dialoge-title-breadcrum">
                                <b>Search Record</b>
                              </p>
                              <BreadCrums
                                name={`${type} Record Group Name`}
                                code={basicInfoData?.groupCode}
                                description={`${type} Record Group Description`}
                                descriptionValue={basicInfoData?.groupDescription}
                              />
                            </div>
                          }
                          maxWidth="xl"
                        >
                          {/* {exportManagerRecordGroup ? (
                            <SearchExportRecordGroupTable isMapRecordGroup={true} />
                          ) : ( */}
                          <SearchImportRecordGroupTable
                            isRecordGroup={true}
                            recordGroupType={recordType}
                            fixedLength={fixedLength}
                            tempSelectedRows={tempSelectedRows}
                            setTempSelectedRows={setTempSelectedRows}
                            recordGroupValues={values}
                            setDMFieldValue={setFieldValue}
                            handleClose={handleClose}
                            mapRecord={true}
                            includeAudit={basicInfoData?.includeAudit}
                            category={basicInfoData?.category}
                            exportManagerRecordGroup={exportManagerRecordGroup}
                            masterRecordValue={masterRecordCondition ? masterRecordRef.current : ''}
                            type={type}
                          />
                          {/* )} */}
                        </DialogBox>
                      </>
                    );
                  }}
                />

                <div className="d-flex justify-content-center new-standard-textfields mt-3">
                  <Button
                    type="button"
                    onClick={() => {
                      handleDirty && handleDirty(dirty);
                      handleBack();
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {masterRecordCondition ? (
                    <>
                      {/* {basicInfoData?.isDraft === "N" && ( */}
                      <Tooltip
                        title={
                          disabledCondition(values?.groupRecords) ?
                              `Please add Master Record` :
                            ''
                        }
                      >
                        <span>
                          <Button
                            variant="outlined"
                            type="button"
                            className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                            disabled={
                              disabledCondition(values?.groupRecords) ||
                                (editExisting === 'Export Record Group' &&
                                  !exportRecordGroupAccess?.edit) ||
                                (editExisting === 'Import Record Group' &&
                                  !importRecordGroupAccess?.edit) ||
                                (editExisting === 'Export Manager' &&
                                  !exportManagerRecordGroup?.edit) || enabledSubmission
                            }
                            onClick={() => {
                              saveRef.current = true;
                              handleDirty(false, 'fixed');
                              submitForm();
                            }}
                          >
                            Save
                          </Button>
                        </span>
                      </Tooltip>
                      {/* )} */}
                      <Tooltip
                        title={
                          disabledCondition(values?.groupRecords) ?
                            `Please add one Master Record` :
                            ''
                        }
                      >
                        <span>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`mx-1 search-btn ${classes.buttonRoot}`}
                            disabled={
                              disabledCondition(values?.groupRecords) ||
                              (editExisting === 'Export Record Group' &&
                                !exportRecordGroupAccess?.edit) ||
                              (editExisting === 'Import Record Group' &&
                                !importRecordGroupAccess?.edit) ||
                              (editExisting === 'Export Manager' && !exportManagerRecordGroup?.edit) || enabledSubmission
                            }
                            onClick={() => {
                              saveRef.current = false;
                            }}
                          >
                            Save & Next
                          </Button>
                        </span>
                      </Tooltip>
                    </>
                  ) : (
                    <>
                      {basicInfoData?.isDraft === 'N' && (
                        <Tooltip
                          title={
                            values?.groupRecords?.length === 0 ?
                              `Please add at least one Record` :
                              ''
                          }
                        >
                          <span>
                            <Button
                              variant="outlined"
                              type="button"
                              className={`search-btn ml-1 mr-1 ${classes.buttonRoot}`}
                              disabled={
                                values?.groupRecords?.length === 0 ||
                                (editExisting === 'Export Record Group' &&
                                  !exportRecordGroupAccess?.edit) ||
                                (editExisting === 'Import Record Group' &&
                                  !importRecordGroupAccess?.edit) || enabledSubmission
                              }
                              onClick={() => {
                                saveRef.current = true;
                                handleDirty(false, 'fixed');
                                submitForm();
                              }}
                            >
                              Save
                            </Button>
                          </span>
                        </Tooltip>
                      )}
                      <Tooltip
                        title={
                          values?.groupRecords?.length === 0 ? `Please add at least one Record` : ''
                        }
                      >
                        <span>
                          <Button
                            type="submit"
                            variant="outlined"
                            className={`mx-1 search-btn ${classes.buttonRoot}`}
                            disabled={
                              values?.groupRecords?.length === 0 ||
                              (editExisting === 'Export Record Group' &&
                                !exportRecordGroupAccess?.edit) ||
                              (editExisting === 'Import Record Group' &&
                                !importRecordGroupAccess?.edit) || enabledSubmission
                            }
                            onClick={() => {
                              saveRef.current = false;
                            }}
                          >
                            Save & Next
                          </Button>
                        </span>
                      </Tooltip>
                    </>
                  )}
                </div>
              </Form>
            </>
          );
        }}
      </Formik>
      {(isLoading || printUsageIsLoading) && <PageLoader />}
      {(errorMsg || printUsageErrorMsg) && (
        <ErrorSnackbar errorMsg={printUsageErrorMsg || errorMsg} />
      )}
      {(printUsageSuccessMsg || successMsg) && (
        <SuccessSnackbar successMsg={successMsg || printUsageSuccessMsg} />
      )}
    </>
  );
}
export default MapRecordGroup;
